import { Controller } from '@hotwired/stimulus'

export default class extends Controller<HTMLElement> {
  connect(): void {
    this.updateSelectionState()
    this.bindRadioEvents()
  }

  handleSelectionChange(event: Event): void {
    const radioInput = event.target as HTMLInputElement
    if (radioInput.type === 'radio') {
      this.updateSelectionState()
    }
  }

  private updateSelectionState(): void {
    const radioInputs = this.element.querySelectorAll('input[type="radio"]')

    radioInputs.forEach((radio) => {
      const radioInput = radio as HTMLInputElement
      const itemRow = radioInput
        .closest('[data-sf-inpage-list-target="item"]')
        ?.querySelector('[data-sf-inpage-list-target="itemRow"]') as HTMLElement

      if (itemRow) {
        if (radioInput.checked) {
          itemRow.classList.remove('hover:tw-bg-sf-snow-light')
          itemRow.classList.add(
            'tw-bg-sf-primary-subtle',
            'hover:tw-bg-sf-primary-subtle'
          )
        } else {
          itemRow.classList.remove(
            'tw-bg-sf-primary-subtle',
            'hover:tw-bg-sf-primary-subtle'
          )
          itemRow.classList.add('hover:tw-bg-sf-snow-light')
        }
      }
    })
  }

  private bindRadioEvents(): void {
    const radioInputs = this.element.querySelectorAll('input[type="radio"]')

    radioInputs.forEach((radio) => {
      radio.addEventListener('change', () => {
        this.updateSelectionState()
      })
    })
  }
}
